import {createSelector} from 'reselect'
import {isPTOEnabled, isSDBEnabled, isWASEnabled} from '../../../../../features/selectors'

export const getViewerSettings = (state) => state.userManagement.common.viewerSettings

export const isPTOTabAvailable = createSelector(
    getViewerSettings,
    isPTOEnabled,
    (viewerSettings, isPtoEnabled) => viewerSettings.allowedToManageLeaveBalanceSettings && isPtoEnabled
)

export const isSDBTabAvailable = createSelector(
    getViewerSettings,
    isSDBEnabled,
    (viewerSettings, isSDBEnabled) => viewerSettings.allowedToManageLeaveBalanceSettings && isSDBEnabled
)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/userTable/selectors.js